import React, { useState } from "react";

import { Grid } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";


import Header from "./components/Header";
import BillTable from "./components/BillTable";
import Footer from "./components/Footer";
import { Link } from "react-router-dom";

function QuotationBill() {
  const [toDefault, setToDefault] = useState(0);

  return (
    <Box sx={{p:0.5, minHeight:'100vh'}} >
      <Box sx={{ flexGrow: 1, mb: 1.5,}}>
        <AppBar position="static" sx={{background:' #01a3b6'}}>
          <Toolbar variant="dense">
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              Quotation Bill
            </Typography>
            <Link to="/master/product" style={{color:'#fff'}}>
            <Button color="inherit" >Home</Button>
            </Link>
          </Toolbar>
        </AppBar>
      </Box>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Header toDefault={toDefault} />
        </Grid>
        <Grid item xs={12}>
          <BillTable />
        </Grid>
        <Grid item xs={12}>
          <Footer setToDefault={setToDefault} />
        </Grid>
      </Grid>
    </Box>
  );
}

export default QuotationBill;
